//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import { required } from 'vuelidate/lib/validators'

const crcolumns = [
  { name: 'company', label: '所属公司', field: 'company' },
  { name: 'tplus_number', label: 'T+编码', field: 'tplus_number' },
  { name: 'simple_name', label: '渠道简称', field: 'simple_name' },
  { name: 'channelInfoStr', label: '代理商信息', field: 'channelInfoStr' },
  { name: 'useIn400', label: '400系统', field: 'useIn400' },
  { name: 'isDel', label: '状态', field: 'isDel' },
  { name: 'company_name', label: '财务开票单位', field: 'company_name' },
  { name: 'manager', label: '负责人', field: 'manager' },
  { name: 'update_time', label: '更新时间', field: 'update_time' },
]


export default {
  name: 'Home',
  data() {
    return {
      selected:[],
      form: {
        username: '',
        password: '',
        vcode: ''
      },
      filter:'',
      loading: false,
      pagination: {
        sortBy: 'desc',
        descending: false,
        page: 1,
        rowsPerPage: 1,
        rowsNumber: 20
      },
      channelTabelColumns: crcolumns,
      channels: [],
      orderOptions: [],
      orderModel: null,
      loading4: false
    }
  },
  components: {
    required
  },
  validations: {
    form: {
      username: { required }
    }
  },
  mounted() {
    var that = this;
    this.loading = true
    this.onRequest({
      pagination: this.pagination,
      filter: undefined
    });
  },
  methods: {
    onRequest(props){
      console.log(props)
      var that=  this
      let pagin  = props.pagination
      let kk = ''
      if(props.filter!=undefined){
        kk = props.filter
      }
      this.$axios
      .get('/api/admin/channel?from=quasar&page='+pagin.page+"&channelName="+kk)
      .then(function (response) {
        that.loading = false
        let data = response.data.data;
        that.channels = data.list;
        that.pagination.page = data.pageInfo.page
        that.pagination.rowsPerPage = data.pageInfo.size
        that.pagination.rowsNumber = data.total
        })
      .catch(function (error) { // 请求失败处理
        that.loading = false
        console.log(error);
      });
    },
    dblclick(evt, row){
      console.log(row)
      //this.$router.push('/order/detail/'+row['enId'])
    },
    addChannel(){
        this.$router.push('/channel/edit/0')
    },
    editChannel(){
      if(this.selected.length<1){
        this.$q.notify({
          message: '提示',
          caption: '请选择需要操作的记录',
          color: 'purple'
        })
        return;
      }
      let row = this.selected[0];
      this.$router.push('/channel/edit/'+row['enId'])
    },
    showSuccess() {
      this.$q.notify({
        message: '提示',
        caption: '操作成功',
        color: 'secondary'
      })
    },
    showError(msg) {
      this.$q.dialog({
        title: '出错了',
        message: msg
      }).onOk(() => {
        // console.log('OK')
      }).onCancel(() => {
        // console.log('Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    }
  }
}
